import React from "react";
import LegalPage from "./LegalPage";
import { BRAND } from "@/constants/content";

const TermsConditions = () => (
  <LegalPage
    title="Terms & Conditions"
    description="The terms that govern your use of the BoostF website and marathon."
  >
    <p>
      These terms govern your use of {BRAND.name} and your registration for the {BRAND.tagline}.
      By accessing this website or reserving a seat, you agree to these terms.
    </p>

    <h2>1. Registration</h2>
    <p>
      Registration is a one-time payment of ₹{BRAND.price} that reserves your seat in the upcoming
      cohort. Seats are limited and offered on a first-come, first-served basis.
    </p>

    <h2>2. Content and materials</h2>
    <p>
      All marathon content — including recordings, templates, and resources — is provided
      for your personal learning only. It may not be redistributed, resold, or shared
      publicly.
    </p>

    <h2>3. Community conduct</h2>
    <p>
      The private WhatsApp community is a space for serious builders. Spam, self-promotion,
      abusive behavior or off-topic content may lead to removal without refund.
    </p>

    <h2>4. Limitation of liability</h2>
    <p>
      We provide the marathon, mentorship and community with a genuine intent to help you
      launch. Business outcomes depend on many factors and cannot be guaranteed.
    </p>

    <h2>5. Governing law</h2>
    <p>
      These terms are governed by the laws of India. Any disputes shall be subject to the
      exclusive jurisdiction of the courts located in India.
    </p>

    <h2>6. Contact</h2>
    <p>Questions about these terms? Write to {BRAND.supportEmail}.</p>
  </LegalPage>
);

export default TermsConditions;
